import * as React from "react";
import { Container } from "../../components/Container/Container";
import styled from "../../styled-components";
import { media } from "../../breakpoints";

const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.white};
  background-image: url("https://assets.saytechnologies.com/images/marketing-site/careers/say-neon-sign.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 240px 20px 160px;

  ${media.PHONE`
    border-bottom: 1px solid #C9C6C1;
    background-image: none;
    padding-bottom: 65px;
    padding-top: 65px;
  `};
`;

const MobileBackgroundImage = styled.div`
  ${media.PHONE`
    background-image: url("https://assets.saytechnologies.com/images/marketing-site/careers/say-neon-sign.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 200px;
  `};
`;

const Title = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 30px;
  line-height: 40px;
  text-align: center;

  ${media.PHONE`
    text-align: left;
  `};
`;

export const CareersHero = () => (
  <>
    <MobileBackgroundImage />
    <Section>
      <Container maxwidth={900}>
        <Title>
          Say powers connections between shareholders and their investments by
          partnering with the world’s most innovative companies and financial
          institutions.
        </Title>
      </Container>
    </Section>
  </>
);



// WEBPACK FOOTER //
// ./src/pages/Careers/CareersHero.tsx